import React from 'react'
import classes from './ActivityCorruptionRegulations.module.scss'

function ActivityCorruptionRegulations() {
  return (

    
    <div className={` ${classes.activity__corruption__regulations} load-anim`}>

      

      <div className={classes.activity__corruption__regulations__wrapper}>
        <a
          className={classes.activity__corruption__regulations__link}
          target='_blank'
          href="https://lex.uz/docs/3105127"
          rel="noreferrer"
        >
          Постановление Президента Республики Узбекистан "О мерах по реализации положений Закона Республики Узбекистан "О противодействии коррупции” № 2752 от 02.02.2017 года
        </a>

        <a
          className={classes.activity__corruption__regulations__link}
          target='_blank' href="https://lex.uz/docs/1369507"
          rel="noreferrer"
        >
          Закон Республики Узбекистан "О присоединении Республики Узбекистан к Конвенции Организации Объединенных Наций против коррупции" (Нью-Йорк, 31 октября 2003 года)
        </a>
      </div>

      <div className={classes.activity__corruption__regulations__wrapper}>
        <a
          className={classes.activity__corruption__regulations__link}
          target='_blank'
          href="https://lex.uz/docs/2911871"
          rel="noreferrer"
        >
          Постановление Кабинета Министров Республики Узбекистан "Об утверждении типовых правил этического поведения работников органов государственного управления и органов исполнительной власти на местах” № 62 от 02.03.2016 года
        </a>

        <a
          className={classes.activity__corruption__regulations__link}
          target='_blank' href="https://lex.uz/docs/3088013"
          rel="noreferrer"
        >
          Закон Республики Узбекистан "О противодействии коррупции” от 03.01.2017 года 
        </a>
      </div>

      <div className={classes.activity__corruption__regulations__wrapper}>
        <a
          className={classes.activity__corruption__regulations__link}
          target='_blank'
          href="https://lex.uz/uz/docs/2248650?ONDATE=25.02.2022"
          rel="noreferrer"
        >
          Закон Республики Узбекистан "О внесении изменений и дополнений, а также признании утратившими силу некоторых законодательных актов Республики Узбекистан"
        </a>

        <a
          className={classes.activity__corruption__regulations__link}
          target='_blank' href="https://lex.uz/docs/4355399"
          rel="noreferrer"
        >
          Указ Президента Республики Узбекистан " О мерах по дальнейшему совершенствованию системы противодействия коррупции в Республике Узбекистан"
        </a>
      </div>
    </div>
  )
}

export default ActivityCorruptionRegulations